document.addEventListener('change', event => {
  if (event.target.matches('[data-catalog-sort], .bp-catalog-desktop input[type=checkbox], .bp-catalog-desktop input[type=number]')) event.target.form.requestSubmit();
});

document.addEventListener('reset', event => {
  if (!event.target.matches('.bp-search-form')) return;
  event.preventDefault();
  const input = event.target.querySelector('input[type="search"]');
  input.value = '';
  input.focus();
});

// Keep native details keyboard behavior while treating desktop facets as popovers.
document.addEventListener('toggle', event => {
  const current = event.target;
  if (!current.matches('.bp-catalog-filter') || !current.open) return;
  current.closest('form').querySelectorAll('.bp-catalog-filter[open]').forEach(details => {
    if (details !== current) details.open = false;
  });
}, true);

document.addEventListener('click', event => {
  document.querySelectorAll('.bp-catalog-filter[open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('.bp-catalog-filter[open]');
  if (!details) return;
  event.preventDefault();
  details.open = false;
  details.querySelector('summary').focus();
});

if (!customElements.get('bp-mobile-filters')) {
  customElements.define('bp-mobile-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-filter-open]');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-filter-open]')) this.dialog.showModal();
        if (event.target.closest('[data-filter-close]')) this.dialog.close();
        const back = event.target.closest('[data-filter-back]');
        if (back) back.closest('details').open = false;
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.querySelectorAll('details[open]').forEach(details => details.open = false);
        this.opener.focus();
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
